import SectionHeader from "@/components/ui/section-header";

const MODES = [
  {
    title: "Rotierende Sessions",
    body: "Eine neue Residential-IP wird gemäß dem konfigurierten Rotationsverhalten zugewiesen — nützlich für unabhängige Beobachtungen, bei denen jede Anfrage nicht dieselbe Exit-IP wie die vorherige teilen muss. Das genaue Rotationsverhalten kann auch davon abhängen, ob der Client eine bestehende Verbindung wiederverwendet.",
  },
  {
    title: "Sticky Sessions",
    body: "Dieselbe Residential-IP bleibt für eine festgelegte Dauer zugewiesen — nützlich für zusammenhängende Anfragen, etwa einen mehrstufigen Login- oder Checkout-Ablauf, die eine konstante Exit-IP über die gesamte Session benötigen.",
  },
];

export default function ResidentialSessionModesDe() {
  return (
    <section
      className="py-section-sm border-border border-b"
      aria-labelledby="residential-session-modes-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <SectionHeader
            eyebrow="Session-Verhalten"
            id="residential-session-modes-heading"
            heading="Rotierende und sticky Residential-Proxy-Sessions"
            body="Rotierenden Modus für unabhängige Beobachtungen nutzen, sticky Sessions für zusammenhängende Anfragen, die einen konstanten Exit benötigen."
          />
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {MODES.map((mode) => (
            <div key={mode.title} className="border-border bg-card rounded-2xl border p-6">
              <h3 className="text-foreground mb-2 text-base font-semibold">{mode.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{mode.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
